import { Component, Input } from '@angular/core';
import { MemberDto } from '../../../../../service/dto';

@Component({
  selector: 'app-member-view-memberships',
  standalone: false,
  templateUrl: './member-view-memberships.component.html',
  styleUrl: './member-view-memberships.component.scss'
})
export class MemberViewMembershipsComponent {
	@Input() member!: MemberDto;
}
